module.exports = __webpack_public_path__ + "static/UnqMakkA-54896a1baea2677054e41ad9c975daaf.gif";